import { GlTooltipDirective, GlIcon, GlTooltip } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { humanTimeframe, newDate } from '~/lib/utils/datetime_utility';
import { getIterationPeriod } from 'ee/iterations/utils';
import WorkItemRelationshipPopoverMetadata from '../../../../../../../app/assets/javascripts/work_items/components/shared/work_item_relationship_popover_metadata.vue?vue3';
import { findIterationWidget, findStartAndDueDateWidget, findWeightWidget } from '../../../../../../../app/assets/javascripts/work_items/utils.js?vue3';
export default {
    name: 'WorkItemRelationshipPopoverMetadataEE',
    components: {
        GlIcon,
        GlTooltip,
        WorkItemRelationshipPopoverMetadata
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        workItem: {
            type: Object,
            required: true
        },
        workItemFullPath: {
            type: String,
            required: true
        }
    },
    computed: {
        workItemWeight () {
            return findWeightWidget(this.workItem)?.weight;
        },
        workItemIteration () {
            return findIterationWidget(this.workItem)?.iteration;
        },
        workItemStartDate () {
            return findStartAndDueDateWidget(this.workItem)?.startDate;
        },
        workItemDueDate () {
            return findStartAndDueDateWidget(this.workItem)?.dueDate;
        },
        showDate () {
            return this.workItemStartDate || this.workItemDueDate;
        },
        workItemTimeframe () {
            return humanTimeframe(newDate(this.workItemStartDate), newDate(this.workItemDueDate));
        },
        iterationPeriod () {
            return getIterationPeriod(this.workItemIteration);
        },
        iterationTitle () {
            return this.workItemIteration?.title;
        },
        iterationCadenceTitle () {
            return this.workItemIteration?.iterationCadence?.title;
        }
    }
};
